// src/env/constants.ts
const RUNTIME_ENV_TAGS = [
	"testing",
	"development",
	"production"
];
export { RUNTIME_ENV_TAGS };

//# sourceMappingURL=constants.js.map